import { ReportData } from "@/entry/server/movie";
import { Pagination } from "@/lib/api";
import React, { useEffect, useState } from "react";
import { videoRepo } from "@/repo/video-repo";
import LoadingGif from "@public/img/loading.gif"
import { Link } from "react-router-dom";
import PaginationView from "@/component/commom/pagination";

export default function Page() {
    const [reports, setReports] = useState<ReportData[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [pagination, setPagination] = useState<Pagination | undefined>(undefined);
    const [page, setPage] = useState<number>(1);

    useEffect(() => {
        videoRepo.getReports(page).then((res) => {
            setReports(res.data ?? []);
            setPagination(res.pagination ?? undefined);
            setLoading(false);
        });
    }, [page]);

    return (
        <div className="w-full lg:min-h-[560px] rounded-xl bg-bg2 p-4 flex flex-col gap-4">
            <h2 className="text-2xl font-bold self-start text-white">گزارشات من</h2>

            <div className={`w-full flex-1 flex flex-col gap-4 ${loading || reports.length === 0 ? 'justify-center items-center' : ''}`}>
                {loading && <img src={LoadingGif} alt="loading" />}

                {!loading && reports.length > 0 && (
                    <div className="w-full max-w-full overflow-x-auto">
                        <table className="w-full border-separate border-spacing-y-2 max-w-full overflow-x-auto">
                            <thead>
                                <tr>
                                    <th className="text-sm font-bold text-center">شناسه</th>
                                    <th className="text-sm font-bold text-center">فیلم</th>
                                    <th className="text-sm font-bold text-center">عنوان</th>
                                    <th className="text-sm font-bold text-center hidden sm:block">تاریخ ایجاد</th>
                                    <th className="text-sm font-bold text-center">وضعیت</th>
                                </tr>
                            </thead>
                            <tbody>
                                {reports.map((report) => (
                                    <tr key={report.id} className="text-center">
                                        <td className="border-y border-r border-zinc-700 rounded-r-xl px-3 py-2">{report.id}</td>
                                        <td className="border-y border-zinc-700 px-3 py-2"><Link to={`/${report.movie_type}/${report.movie_id}/${report.movie_slug}`} className="text-sm text-lime-400 hover:underline transition-all duration-300"><span className="line-clamp-1">{report.movie_title}</span></Link></td>
                                        <td className="border-y border-zinc-700 px-3 py-2"><span className="line-clamp-1">{report.title}</span></td>
                                        <td className="border-y border-zinc-700 px-3 py-2 ltr hidden sm:table-cell">{report.created_at}</td>
                                        <td className="border-y border-l rounded-l-xl border-zinc-700 px-3 py-2">
                                            <span className={`text-sm text-zinc-100 rounded-full py-0.5 px-2.5 w-fit ${report.is_resolved ? "bg-emerald-600" : "bg-red-600"}`} style={{ textWrap: "nowrap" }}>
                                                {report.is_resolved ? "برطرف شده" : "درحال بررسی"}
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

            {pagination && <PaginationView pagination={pagination} black={true} onChange={setPage} />}
        </div>
    );
}